// İSG uzmanı portalı — Belge Şemaları TanStack Query anahtarları (GL #7 contract §4.1.2). Kayıt
// platform verisidir (firma kapsamı yok), bu yüzden anahtar firma kimliği İÇERMEZ (§4.7.6). Liste
// anahtarı parametreleri içerir; invalidasyon `typeLists()` önekiyle yapılır.

import { type DocumentTypeAdminListParams, documentTypesKey } from '@isgportal/shared';
import type { QueryClient } from '@tanstack/react-query';

export const schemasKeys = {
  /** Erişim sondası (gate) — hafif liste probu (page=1, pageSize=1). */
  access: () => ['document-schemas', 'access'] as const,

  /** Tüm tür listesi sorgularının öneki (filtre/sayfa varyantlarını kapsar). */
  typeLists: () => ['document-schemas', 'types'] as const,

  /** Sayfalı + filtreli yönetici listesi. */
  typeList: (params: DocumentTypeAdminListParams) => ['document-schemas', 'types', params] as const,
} as const;

/**
 * Her yönetici yazımından (oluştur/güncelle) sonra: yönetici listesi VE herkesin okuduğu kayıt
 * (`GET /document-types`, `documentTypesKey`) tazelenir — yükleme seçicileri ve etiketler aynı
 * oturumda yeni türü/etiketi görür. Erişim sondası bilerek tazelenmez: geçici bir hata kapıyı
 * "ulaşılamıyor"a çevirip açık formu söker.
 */
export function invalidateDocumentTypes(queryClient: QueryClient): void {
  void queryClient.invalidateQueries({ queryKey: schemasKeys.typeLists() });
  void queryClient.invalidateQueries({ queryKey: documentTypesKey });
}
